import { colorPrimary } from '@/assets/styles/public.scss'

export default {
  colorPrimary
}
